import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent} from 'react'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const PrimeDayInfo: FunctionComponent = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {domainName} = getDomainConfig(domain, locale)

  const isBestReviews = domainName === 'bestreviews'

  return !isBestReviews ? (
    <div className="flex flex-row items-center desktop:ml-2">
      <span className="text-base font-extrabold leading-5 tablet:text-xs tablet:leading-4">
        {translations.AppBar.primeBig}
        <br />
        {translations.AppBar.dealDays}
      </span>
      <div className="h-14 mobile:hidden">
        <img
          src="/icons/lightThunderPrimeDay.png"
          alt="prime day thunder"
          className="tablet h-14 shrink-0 object-scale-down"
        />
      </div>
    </div>
  ) : (
    <div className="ml-10 flex flex-row items-center tablet:ml-auto tablet:mr-5">
      <div className="flex flex-row items-center">
        <span className="text-base font-extrabold leading-5 tablet:text-xs tablet:leading-4">
          {translations.AppBar.primeBig}
          <br />
          {translations.AppBar.dealDays}
        </span>
        <div className="h-14">
          <img
            src="/icons/lightThunderPrimeDay.png"
            alt="prime day thunder"
            className="tablet h-14 shrink-0 object-scale-down"
          />
        </div>

        <div className="flex h-8 w-14 flex-row items-start gap-1 tablet:h-5 tablet:w-8">
          <img
            src="/icons/prime-white-logo.png"
            alt="prime day logo"
            className="h-8 w-14 shrink-0 object-scale-down tablet:h-5 tablet:w-8"
          />
        </div>
      </div>
    </div>
  )
}

export default PrimeDayInfo
